import { OperatorValueTypeEnum } from '@y42/json-schema';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {
  endOfMonth,
  endOfQuarter,
  endOfWeek,
  endOfYear,
  startOfMonth,
  startOfQuarter,
  startOfWeek,
  startOfYear,
  subDays,
  subMonths,
  subQuarters,
  subWeeks,
  subYears,
} from 'date-fns';
import { AbsoluteDateRangePreset, RelativeDateRangePreset } from '../../../operation-input.model';

const now = new Date();

export const defaultAbsoluteRangePresets: AbsoluteDateRangePreset[] = [
  { label: 'Today', start: now, end: now },
  { label: 'Yesterday', start: subDays(now, 1), end: subDays(now, 1) },
  {
    label: 'Last 7 days',
    start: subDays(now, 6),
    end: now,
  },
  {
    label: 'Last 14 days',
    start: subDays(now, 13),
    end: now,
  },
  {
    label: 'Last 28 days',
    start: subDays(now, 27),
    end: now,
  },
  {
    label: 'Last 30 days',
    start: subDays(now, 29),
    end: now,
  },
  {
    label: 'This week (starts Sunday)',
    start: startOfWeek(now, { weekStartsOn: 0 }),
    end: endOfWeek(now, { weekStartsOn: 0 }),
  },
  {
    label: 'This week to date (starts Sunday)',
    start: startOfWeek(now, { weekStartsOn: 0 }),
    end: now,
  },
  {
    label: 'Last week (starts Sunday)',
    start: startOfWeek(subWeeks(now, 1), { weekStartsOn: 0 }),
    end: endOfWeek(subWeeks(now, 1), { weekStartsOn: 0 }),
  },
  {
    label: 'This week (starts Monday)',
    start: startOfWeek(now, { weekStartsOn: 1 }),
    end: endOfWeek(now, { weekStartsOn: 1 }),
  },
  {
    label: 'This week to date (starts Monday)',
    start: startOfWeek(now, { weekStartsOn: 1 }),
    end: now,
  },
  {
    label: 'Last week (starts Monday)',
    start: startOfWeek(subWeeks(now, 1), { weekStartsOn: 1 }),
    end: endOfWeek(subWeeks(now, 1), { weekStartsOn: 1 }),
  },
  {
    label: 'This month',
    start: startOfMonth(now),
    end: endOfMonth(now),
  },
  {
    label: 'This month to date',
    start: startOfMonth(now),
    end: now,
  },
  {
    label: 'Last month',
    start: startOfMonth(subMonths(now, 1)),
    end: endOfMonth(subMonths(now, 1)),
  },
  {
    label: 'This quarter',
    start: startOfQuarter(now),
    end: endOfQuarter(now),
  },
  {
    label: 'This quarter to date',
    start: startOfQuarter(now),
    end: now,
  },
  {
    label: 'Last quarter',
    start: startOfQuarter(subQuarters(now, 1)),
    end: endOfQuarter(subQuarters(now, 1)),
  },
  {
    label: 'This year',
    start: startOfYear(now),
    end: endOfYear(now),
  },
  {
    label: 'This year to date',
    start: startOfYear(now),
    end: now,
  },
  {
    label: 'Last year',
    start: startOfYear(subYears(now, 1)),
    end: endOfYear(subYears(now, 1)),
  },
];

export const defaultRelativeRangePresets: RelativeDateRangePreset[] = [
  {
    label: 'Last 7 days',
    valueType: OperatorValueTypeEnum.Days,
    from: -6,
    to: 0,
  },
  {
    label: 'Last 14 days',
    valueType: OperatorValueTypeEnum.Days,
    from: -13,
    to: 0,
  },
  {
    label: 'Last 28 days',
    valueType: OperatorValueTypeEnum.Days,
    from: -27,
    to: 0,
  },
  {
    label: 'Last 30 days',
    valueType: OperatorValueTypeEnum.Days,
    from: -29,
    to: 0,
  },
  {
    label: 'This week',
    valueType: OperatorValueTypeEnum.Weeks,
    from: 0,
    to: 0,
  },
  {
    label: 'Last week',
    valueType: OperatorValueTypeEnum.Weeks,
    from: -1,
    to: -1,
  },
  {
    label: 'This week (ISO)',
    valueType: OperatorValueTypeEnum.Isoweek,
    from: 0,
    to: 0,
  },
  {
    label: 'Last week (ISO)',
    valueType: OperatorValueTypeEnum.Isoweek,
    from: -1,
    to: -1,
  },
  {
    label: 'This month',
    valueType: OperatorValueTypeEnum.Months,
    from: 0,
    to: 0,
  },
  {
    label: 'Last month',
    valueType: OperatorValueTypeEnum.Months,
    from: -1,
    to: -1,
  },
  {
    label: 'This year',
    valueType: OperatorValueTypeEnum.Years,
    from: 0,
    to: 0,
  },
  {
    label: 'Last year',
    valueType: OperatorValueTypeEnum.Years,
    from: -1,
    to: -1,
  },
];
